export default function Loading() {
  return (
    <span className="loading loading-spinner loading-sm md:loading-md"></span>
  );
}
